import { Button, Grid, MenuItem } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { SelectValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEspecialidades } from '../../../../actions/especialidades';
import LoadingBeforeViewData from '../../../compartidos/LoadingBeforeViewData';
import { fetchCentrosMedicosPropios } from '../../../../actions/centrosMedicosPropios';
import { KeyboardDatePicker, KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import moment from 'moment';
import { armarParametros } from '../../../../helpers/parametros';
import { fetchConToken } from '../../../../helpers/fetch';
import { OBRAS_SOCIALES, STEPPER_CERTIFICADO_DIGITAL } from '../../../../utils/constants';
import { nuevoCertificadoAsistencia, setActiveStep } from '../../../../actions/certificadoAtencion/certificadoAtencionActions';

const fechaActual = new Date();

export const CertificadoAtencionDetalleOrdenInformacion = (props) => {

    const { idObraSocial } = props;
    const dispatch = useDispatch();
    const [idEspecialidad, setIdEspecialidad] = useState('');
    const [idCentroMedico, setIdCentroMedico] = useState('');
    const [idEfectorRed, setIdEfectorRed] = useState('');
    const [hora, setHora] = React.useState(new Date());
    const [listaEfectoresRed, setListaEfectoresRed] = useState([]);
    const [fecha, setFecha] = useState(fechaActual);
    const especialidades = useSelector((state) => state.especialidades);
    const centrosMedicosPropios = useSelector(state => state.centrosMedicosPropios)
    const { afiliadoSeleccionado } = useSelector(state => state.certificadoAtencion)


    useEffect(() => {
        dispatch(fetchEspecialidades(false))
        dispatch(fetchCentrosMedicosPropios())
    }, [dispatch]);

    useEffect(() => {

        const traerDatos = async () => {
            const parametros = armarParametros(idEspecialidad, idCentroMedico, null, null, null, null, null, null, null);
            const response = props.porCentroMedico ? await fetchConToken(`EfectorP/traerPorCentroMedico?${parametros}`) : await fetchConToken(`EfectorP/traerPorEspecialidad?${parametros}`);
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                const lista = await response.json();
                if (response.ok && lista) {
                    let listaFromApi = lista.map((item) => {
                        return {
                            value: item.idEfectorRed,
                            display: item.nombreEfector,
                        };
                    });
                    setListaEfectoresRed(listaFromApi);
                }
            }
        };
        traerDatos();
    }, [idEspecialidad, idCentroMedico]);



    const EspecialidadesOptions = especialidades.items.map(item => ({
        value: item.idEspecialidades,
        label: item.descripcionEspecialidades,
    }));

    const CentrosMedicosOptions = centrosMedicosPropios.items.map(item => ({
        value: item.idCentroMedico,
        label: item.descripcionCentro,
    }))

    if (centrosMedicosPropios.cargada === false || especialidades.cargada === false) {
        return <LoadingBeforeViewData />
    }


    const submitHandler = () => {
        const horaFormateada = hora ? moment(hora).format('HH:mm:ss') : null;
        const data = {
            idAfiliado: idObraSocial === OBRAS_SOCIALES.OSPEDYC ? afiliadoSeleccionado?.id_afiliado : null,
            idAfiliadoExterno: idObraSocial !== OBRAS_SOCIALES.OSPEDYC ? afiliadoSeleccionado?.id_afiliado : null,
            idCentroMedico: idCentroMedico,
            idEspecialidad: idEspecialidad,
            idEfectorRed: idEfectorRed,
            fechaCarga: fecha,
            hora: horaFormateada
        }
        dispatch(nuevoCertificadoAsistencia(data))
        dispatch(setActiveStep(STEPPER_CERTIFICADO_DIGITAL.CONFIRMACION));
    }

    return (
        <React.Fragment>
            <ValidatorForm onSubmit={submitHandler}>
                <Grid
                    container
                    spacing={1}
                    direction="row"
                    justify="center"
                    alignItems="center"
                >
                    <Grid item style={{ display: "flex", flexDirection: "column" }} xs={8}>
                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                margin="normal"
                                label="Fecha"
                                format="dd/MM/yyyy"
                                // required={true}
                                clearLabel="Limpiar"
                                cancelLabel="Cancelar"
                                value={
                                    moment(fecha).isValid() ? moment(fecha) : null
                                }
                                onChange={(date) => {
                                    if (moment(date).isValid()) {
                                        setFecha(date); // Almacena el objeto Date directamente
                                    } else {
                                        setFecha(null); // Manejo de fechas inválidas
                                    }
                                }}
                                KeyboardButtonProps={{
                                    "aria-label": "change date",
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item style={{ display: "flex", flexDirection: "column", marginTop: "1rem" }} xs={8}>
                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                            <KeyboardTimePicker
                                margin="normal"
                                label="Hora"
                                clearLabel="Limpiar"
                                cancelLabel="Cancelar"
                                value={hora}
                                onChange={(e) => {
                                    setHora(e);
                                }}
                                KeyboardButtonProps={{
                                    "aria-label": "change time",
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item style={{ display: "flex", flexDirection: "column", marginTop: "1rem" }} xs={8}>
                        {Array.isArray(CentrosMedicosOptions) && CentrosMedicosOptions.length > 0 && (
                            <SelectValidator
                                fullWidth
                                label="Seleccionar Centro Médico"
                                name="Centro Médico"
                                value={idCentroMedico}
                                onChange={(e) => setIdCentroMedico(e.target.value)}
                                validators={['required']}
                                errorMessages={['Este campo es requerido']}
                            >
                                {CentrosMedicosOptions.map((t, index) => (
                                    <MenuItem key={index}
                                        value={t.value}
                                    >
                                        {t.label}
                                    </MenuItem>
                                ))}
                            </SelectValidator>
                        )}
                    </Grid>
                    <Grid item style={{ display: "flex", flexDirection: "column", marginTop: "1rem" }} xs={8}>
                        {Array.isArray(EspecialidadesOptions) && EspecialidadesOptions.length > 0 && (
                            <SelectValidator
                                fullWidth
                                label="Seleccionar Especialidad"
                                name="Especialidad"
                                value={idEspecialidad}
                                onChange={(e) => setIdEspecialidad(e.target.value)}
                                validators={['required']}
                                errorMessages={['Este campo es requerido']}
                            >
                                {EspecialidadesOptions.map((t, index) => (
                                    <MenuItem key={index}
                                        value={t.value}
                                    >
                                        {t.label}
                                    </MenuItem>
                                ))}
                            </SelectValidator>
                        )}
                    </Grid>
                    <Grid item style={{ display: "flex", flexDirection: "column", marginTop: "1rem" }} xs={8}>
                        {Array.isArray(listaEfectoresRed) && listaEfectoresRed.length > 0 && (
                            <SelectValidator
                                fullWidth
                                label="Seleccionar Profesional"
                                name="Profesional"
                                value={idEfectorRed}
                                onChange={(e) => setIdEfectorRed(e.target.value)}
                                validators={['required']}
                                errorMessages={['Este campo es requerido']}
                            >
                                {listaEfectoresRed.map((t, index) => (
                                    <MenuItem key={index}
                                        value={t.value}
                                    >
                                        {t.display}
                                    </MenuItem>
                                ))}
                            </SelectValidator>
                        )}
                    </Grid>

                </Grid>
                <div
                    style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
                >
                    {/* <Button
                        variant="contained"
                        color="secondary"
                        style={{ marginRight: "3rem" }}
                        // onClick={() => {
                        //     dispatch(setShowForm(true));
                        // }}
                    >
                        Anterior
                    </Button> */}
                    <Button variant="contained" color="primary" type="submit">
                        Siguiente
                    </Button>
                </div>
            </ValidatorForm>
        </React.Fragment>
    )
}
